import React, { Component } from "react";
import ActionCreators from "../store/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ClientsTable from "../Components/ClientsTableComponent/ClientsTableComponent";
import ClientDialog from "../Components/ClientDialog/ClientDialog";
import styled from "styled-components";
import Axios from "../config/AxiosConfig";
import moment from "moment";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

const ClientsWrapper = styled.div`
  width: 100vw;
  max-height: 90vh;
  margin: auto;
  overflow-x: hidden;
`;

const Header = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: baseline;
  position: sticky;
  top: 0px;
  background-color: white;
  width: 100vw;
  padding-top:32px
  padding-left: 32px;
  padding-bottom: 32px;
`;

class ClientsView extends Component {
  state = {
    isDialogOpen: false,
    isNewClient: true,
    isError: false,
    textFilter: "",
    clientSelected: {
      id_klient: "",
      nazwa: "",
      id_rodzaj: "",
      rodzaj: "",
      ulica: "",
      kod: "",
      miasto: "",
      dowod: "",
      prawo_jazdy: "",
      data_prawa_jazdy: "",
      pesel: "",
      nip: "",
      telefon: "",
      regon: "",
      uwagi: "",
      limitkm: "",
      kierowca_imie: "",
      kierowca_ulica: "",
      kierowca_kod: "",
      kierowca_miasto: "",
      kierowca_pesel: "",
      kierowca_telefon: "",
      organ: ""
    }
  };

  onDialogSwitchHandler(isNewClient) {
    let isDialogOpen = !this.state.isDialogOpen;
    this.setState({ isDialogOpen, isNewClient, isError: false });
  }

  onSelectedIdChangeHandler = id => {
    if (id) {
      const clientSelected = this.props.clients.find(client => client.id_klient === id);
      this.setState({ clientSelected });
    } else {
      this.setState({
        clientSelected: {
          id_klient: "",
          nazwa: "",
          id_rodzaj: "",
          rodzaj: "",
          ulica: "",
          kod: "",
          miasto: "",
          prawo_jazdy: "",
          data_prawa_jazdy: "",
          pesel: "",
          nip: "",
          telefon: "",
          regon: "",
          uwagi: "",
          limitkm: "",
          kierowca_imie: "",
          kierowca_ulica: "",
          kierowca_kod: "",
          kierowca_miasto: "",
          kierowca_pesel: "",
          kierowca_telefon: "",
          organ: ""
        }
      });
    }
  };

  onClientChangeHandler(event) {
    const client = { ...this.state.clientSelected };
    if (event.target.name === "data_prawa_jazdy") {
      client[event.target.name] = moment(event.target.value).unix();
    } else {
      client[event.target.name] = event.target.value;
    }
    this.setState({ clientSelected: client });
  }

  onClientSaveHandler(client, token) {
    let url = this.state.isNewClient
      ? "kalendarz/dodaj_klient.php"
      : `kalendarz/edytuj_klient.php?id_klient=${client.id_klient}`;
    if (!this.state.isNewClient) {
      Axios.put(url, {
        ...client,
        token
      })
        .then(response => {
          const updatedClient = response.data.klient[0];
          this.props.updateClients(updatedClient);
          this.onDialogSwitchHandler();
          this.setState({ isError: false });
        })
        .catch(error => {
          this.setState({ isError: true });
        });
    } else {
      Axios.post(url, {
        ...client,
        token
      })
        .then(response => {
          const updatedClient = response.data.klient[0];
          this.props.updateClients(updatedClient);
          this.onDialogSwitchHandler();
          this.setState({ isError: false });
        })
        .catch(error => {
          this.setState({ isError: true });
        });
    }
  }

  handleClientDelete = id => {
    this.props.deleteClient(id);
  };

  onFilterChangeHandler = event => {
    this.setState({ textFilter: event.target.value });
  };

  onFilterResetHandler = () => {
    this.setState({ textFilter: "" });
  };

  componentDidMount() {
    this.props.fetchClients(this.props.token);
  }

  render() {
    let { isDialogOpen, textFilter } = this.state;

    const { clients } = this.props;
    const filterWords = textFilter.split(" ");

    const filteredClients = clients.filter(client => {
      const values = Object.values(client).map(val => (typeof val === "string") && val.toLowerCase());
      return values.some(val => {
        if (val) {
          for (let index = 0; index < filterWords.length; index++) {
            return val.includes(filterWords[index].toLowerCase().trim());
          }
        }
      });
    });

    return (
      <ClientsWrapper>
        <Header>
          <TextField
            value={textFilter}
            onChange={this.onFilterChangeHandler}
            type="text"
            label="Wyszukaj"
          />
          <Button
            style={{ marginLeft: 16 }}
            variant="outlined"
            onClick={() => {
              this.onFilterResetHandler();
            }}
            color="secondary"
          >
            Wyczyść
          </Button>
          <Button
            style={{ marginLeft: 16 }}
            variant="outlined"
            onClick={() => {
              this.onSelectedIdChangeHandler();
              this.onDialogSwitchHandler(true);
            }}
            color="primary"
          >
            Dodaj Klienta{" "}
          </Button>
        </Header>

        <ClientDialog
          onClientChange={this.onClientChangeHandler.bind(this)}
          isDialogOpen={isDialogOpen}
          client={this.state.clientSelected}
          onClientSave={this.onClientSaveHandler.bind(this)}
          onDialogSwitch={this.onDialogSwitchHandler.bind(this)}
          isError={this.state.isError}
        />

        <ClientsTable
          clientSelectedId={this.state.clientSelectedId}
          onDialogSwitch={this.onDialogSwitchHandler.bind(this)}
          clients={filteredClients}
          onSelectedIdChange={this.onSelectedIdChangeHandler}
          onDelete={this.handleClientDelete}
        />
      </ClientsWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(ActionCreators, dispatch)
  };
};

const mapStateToProps = state => {
  return { clients: state.formReducer.clients, token: state.authReducer.token };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientsView);
